module.exports = __webpack_public_path__ + "img/icon_2.50c399d1.png";